<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="avatar-group">
        <!-- 显示头像 -->
        <span v-for="(user, index) in visibleUsers" :key="user?.user?.id">
          <router-link @click.stop :to="'/profile/' + user?.user?.username" class="del-underline">
            <v-avatar :size="avatarSize" :style="getAvatarStyle(index)" class="avatar-item">
              <v-img v-if="user?.user?.avatar" :src="user?.user?.avatar" :alt="user?.user?.name" />
              <span v-else class="text-h6 font-weight-bold">
                {{ getInitials(user?.user?.name) }}
              </span>
            </v-avatar>
          </router-link>
        </span>
        <!-- 其余数量 -->
        <v-avatar v-if="remainingCount > 0" :size="avatarSize" color="grey lighten-2" :style="getCounterStyle()" class="avatar-counter">
          <span class="text-body-1 font-weight-bold grey--text text--darken-2">
            +{{ remainingCount }}
          </span>
        </v-avatar>
        <span v-if="users.length > 0" class="ml-2 text-white/70 text-sm cursor-pointer gradient-underline-hover view-details" @click="buyersDialog = true">
          <a>View Details ></a>
        </span>
      </div>
      <!-- 弹窗 -->
        <v-dialog v-model="buyersDialog" content-class="v-echarts-dialog" width="680">
            <v-card max-height="600" class="pa-8" rounded="lg" elevation="12" color="white01">
                <v-row no-gutters>
                    <v-col>
                        <v-card-title class="d-flex">
                            <span class="sidebar-h2 text-primaryGrey">Group Buyers Rebate</span>
                            <v-spacer></v-spacer>
                            <v-icon aria-label="close" icon="mdi:mdi-close" class="text-primaryGrey" @click="buyersDialog = false"></v-icon>
                        </v-card-title>
                        <v-divider class="my-4"></v-divider>
                        <v-col cols="12" class="my-2 px-0">
                            <div class="text-primaryGrey" v-for="(user, index) in users" :key="user?.user?.id">
                                <!-- <div class="d-flex flex-nowrap align-center justify-space-between"> -->
                                  <v-row no-gutters class="align-center">
                                    <v-col cols="1">
                                      {{ index + 1 }}
                                    </v-col>
                                    <v-col cols="4">
                                      <div class="body-p text-primaryGrey d-flex flex-nowrap align-center">
                                        <UserAvatar :avatar="user?.user?.avatar" :username="user?.user?.username" :size="48"></UserAvatar>
                                        <div class="ml-5">
                                            <div class="font-weight-bold">{{ user?.user?.name }}</div>
                                            <div class="mt-1" v-username="[user?.user?.username, user?.user?.wallet]"></div>
                                        </div>
                                    </div>
                                    </v-col>
                                    <v-col cols="4" class="text-right">
                                      {{ $tools.formatNumber(user?.rebateUnQuantity, 4) }} UN
                                    </v-col>
                                    <v-col cols="3" class="text-right">
                                      {{ $tools.formatAmount(user?.rebateAmount, 2) }}
                                    </v-col>
                                  </v-row>
                                <!-- </div> -->
                                 <v-divider class="my-2"></v-divider>
                            </div>
                        </v-col>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'UnCryptoGroupRebateAvatarGroup',
  data() {
    return {
      maxVisible: 10,
      avatarSize: 48,
      overlapAmount: 16,
      buyersDialog: false,
    }
  },
  props: {
    users: {
      type: Array,
      default: []
    }

  },
  computed: {
    visibleUsers() {
      return this.users.length > 0 ? this.users.slice(0, this.maxVisible) : [];
    },
    remainingCount() {
      return Math.max(0, this.users.length - this.maxVisible)
    }
  },
  methods: {
    getInitials(name) {
      return name
        .split(' ')
        .map(word => word.charAt(0))
        .join('')
        .toUpperCase()
        .substring(0, 2)
    },
    getAvatarStyle(index) {
      return {
        marginLeft: index > 0 ? `-${this.overlapAmount}px` : '0',
        zIndex: this.maxVisible - index,
        border: '3px solid white',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
      }
    },
    getCounterStyle() {
      return {
        marginLeft: `-${this.overlapAmount}px`,
        zIndex: 0,
        border: '3px solid white',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
      }
    }
  }
}
</script>

<style scoped>
.avatar-group {
  display: flex;
  align-items: center;
}

.avatar-item {
  transition: transform 0.2s ease;
  cursor: pointer;
}

.avatar-item:hover {
  transform: translateY(-4px);
  z-index: 999 !important;
}

.avatar-counter {
  cursor: default;
}
.view-details:hover {
  color: #03DAC5;
}
</style>